import "./LocalSeoConsultantPlymouth.module.css";
import Header from "@/reusable_sections/Header";
import IndustrySectorsGrid from "./sections/IndustrySectorsGrid";
import Services from "./sections/Services";
import Editorial from "./sections/Editorial";
import Casestudyshowcase from "./sections/Casestudyshowcase";
import Methodology from "./sections/Methodology";
import Consultation from "./sections/Consultation";
import Localseohero from "./sections/Localseohero";
import Localseofaq from "./sections/Localseofaq";
import Consultant from "./sections/Consultant";
import Plymouth from "./sections/Plymouth";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantPlymouthPage() {
  return <div>
      <Header />
      <IndustrySectorsGrid />
      <Services />
      <Editorial />
      <Casestudyshowcase />
      <Methodology />
      <Consultation />
      <Localseohero />
      <Localseofaq />
      <Consultant />
      <Plymouth />
      <Footer />
    </div>;
}